import { render, staticRenderFns } from "./InvoiceRecordList.vue?vue&type=template&id=f90b56ca&scoped=true"
import script from "./InvoiceRecordList.vue?vue&type=script&lang=js"
export * from "./InvoiceRecordList.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecordList.vue?vue&type=style&index=0&id=f90b56ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90b56ca",
  null
  
)

export default component.exports